import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Card,
  CardBody,
  Button,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  Container,
  Col,
  Row,
} from "reactstrap";
import dummyImg from "../../assets/images/users/user-dummy-img.jpg";
import { listEmployee, updateEmployee, deleteEmployee } from "./_requests";
import { toast, ToastContainer } from "react-toastify";
import BreadCrumb from "../../Components/Common/BreadCrumb";

const EmployeeViewPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [employee, setEmployee] = useState<any>(null);
  const [changePassword, setChangePassword] = useState("");
  const [deleteModal, setDeleteModal] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  console.log("employee?.passwordText ", employee?.passwordText)
  console.log("employee ", employee)
  useEffect(() => {
    if (id) {
      listEmployee().then((res: any) => {
        const found = res.data.find((e: any) => String(e.id) === String(id));
        setEmployee(found);
      });
    }
  }, [id]);

  const handleChangePassword = async () => {
    if (!changePassword || !employee) return;
    try {
      const formData = new FormData();
      formData.append("password", changePassword);
      formData.append("updated_by", employee.id);
      await updateEmployee(formData, employee.id);
      toast.success("Password updated successfully", { autoClose: 3000 });
      setChangePassword("");
    } catch (error) {
      toast.error("Failed to update password", { autoClose: 3000 });
    }
  };

  const handleGeneratePassword = () => {
    const randomPassword = Math.random().toString().slice(2, 10);
    setChangePassword(randomPassword);
  };

  const handleDelete = async () => {
    try {
      await deleteEmployee(employee.id, employee.id);
      toast.success("Employee deleted successfully", { autoClose: 3000 });
      setDeleteModal(false);
      navigate("/employee");
    } catch (error) {
      toast.error("Failed to delete employee", { autoClose: 3000 });
    }
  };

  if (!employee) return <div>Loading...</div>;

  return (
    <div className="page-content">
      <ToastContainer closeButton={false} limit={1} />
      <Container fluid>
        <BreadCrumb title="Employee Details" pageTitle="Paal Dappa" />

        <Row>
          <Col md={12}>
            <Card>
              <CardBody>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h4></h4>
                  <div>

                    <Button color="danger" onClick={() => setDeleteModal(true)}>
                      <i className="ri-delete-bin-5-fill"></i>
                    </Button>
                  </div>
                </div>

                <Row>
                  <Col lg={4} md={12} className="mb-4">
                    <div className="text-center">
                      <img
                        src={employee.profile || dummyImg}
                        alt="profile"
                        className="avatar-lg rounded-circle object-fit-cover mb-2"
                        style={{ width: "150px", height: "150px" }}
                      />

                    </div>
                  </Col>
                  <Col lg={8} md={12}>

                    <div className="mb-3 row align-items-center">
                      <div className="col-3 text-end">
                        <strong>Name:</strong>
                      </div>
                      <div className="col-4">
                        {employee.name || "-"}
                      </div>
                    </div>

                    <div className="mb-3 row align-items-center">
                      <div className="col-3 text-end">
                        <strong>Role:</strong>
                      </div>
                      <div className="col-4">
                        {employee.role?.roleName || "-"}
                      </div>
                    </div>

                    <div className="mb-3 row align-items-center">
                      <div className="col-3 text-end">
                        <strong>Phone:</strong>
                      </div>
                      <div className="col-4">
                        {employee.contactNumber}
                      </div>
                    </div>

                    <div className="mb-3 row align-items-center">
                      <div className="col-3 text-end">
                        <strong>Email:</strong>
                      </div>
                      <div className="col-4">
                        {employee.email}
                      </div>
                    </div>

                    <div className="mb-3 row align-items-center">
                      <div className="col-3 text-end">
                        <strong>Address:</strong>
                      </div>
                      <div className="col-4">
                        {employee.address}
                      </div>
                    </div>
                  </Col>
                  {/* <div className="mb-3 row align-items-center">
                    <div className="col-3 text-end">
                      <strong>Password:</strong>
                    </div>
                    <div className="col-4 d-flex align-items-center">
                      <span>{showPassword ? (employee?.passwordText || "-") : "********"}</span>
                      <Button
                        size="sm"
                        color="link"
                        className="ms-2 p-0"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        <i className={showPassword ? "ri-eye-off-line" : "ri-eye-line"}></i>
                      </Button>
                    </div>
                  </div> */}


                </Row>

                <hr />

                <div className="text-center mb-2">
                  <h5>Change Password</h5>
                </div>
                <Row className="justify-content-center">
                  <Col md={6}>
                    <div className="d-flex gap-2 mb-2">
                      <Input
                        type="text"
                        placeholder="New Password"
                        value={changePassword}
                        onChange={(e) => setChangePassword(e.target.value)}
                      />
                      <Button color="secondary" onClick={handleGeneratePassword}>
                        Generate
                      </Button>
                    </div>
                    <div className="text-end">
                      <Button
                        color="success"
                        onClick={handleChangePassword}
                        disabled={!changePassword}
                      >
                        Change
                      </Button>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* Delete Confirmation Modal */}
        <Modal isOpen={deleteModal} toggle={() => setDeleteModal(false)} centered>
          <ModalHeader toggle={() => setDeleteModal(false)}>
            Confirm Deletion
          </ModalHeader>
          <ModalBody>
            Are you sure you want to delete the employee <strong>{employee.name}</strong>?
            <div className="mt-3 d-flex justify-content-end gap-2">
              <Button color="secondary" onClick={() => setDeleteModal(false)}>
                Cancel
              </Button>
              <Button color="danger" onClick={handleDelete}>
                Delete
              </Button>
            </div>
          </ModalBody>
        </Modal>
      </Container>
    </div>
  );
};

export default EmployeeViewPage;
